export default {
  views: [
    {
      name: 'Commerce',
      route: '/commerce',
      slug: 'commerce',
      requiresCommerceEditor: true,
      selfServe: true,
    },
    {
      name: 'Media Manager',
      route: '/media-manager',
      slug: 'media-manager',
      requiresMediaManager: true,
      selfServe: true,
    },
    {
      name: 'Brands',
      route: '/brands',
      slug: 'brand_manager',
      requiresCommerceEditor: true,
      selfServe: true,
    },
    {
      name: 'Carts',
      route: '/carts',
      slug: 'carts',
      requiresCommerceEditor: true,
      selfServe: true,
    },
    {
      name: 'Users',
      route: '/users',
      slug: 'users',
      requiresCommerceEditor: true,
      selfServe: true,
    },
    {
      name: 'Inventory',
      route: '/inventoryReport',
      slug: 'inventory_report',
      requiresCommerceEditor: true,
      selfServe: true,
    },
    {
      name: 'Dashboard',
      route: '/dashboard',
      slug: 'dashboard',
      requiresCommerceEditor: false,
      selfServe: true,
    },
  ],
  subnav: {
    'brand_manager': {
      links: [{
        name: 'Brand list',
        route: '/brands',
        slug: 'brands',
        icon: '<i class="fa fa-list"></i>',
        mobileVisible: true,
      },
      {
        name: 'Add Brand',
        route: '/create-brand',
        slug: 'create-brand',
        icon: '<i class="fa fa-plus-circle"></i>',
        mobileVisible: true,
      }],
    },
    'carts': {
      links: [{
        name: 'Cart list',
        route: '/carts',
        slug: 'carts',
        icon: '<i class="fa fa-list"></i>',
        requiresEdit: true,
        mobileVisible: true,
      }, {
        name: 'Add Cart',
        route: '/create-cart',
        slug: 'create-cart',
        icon: '<i class="fa fa-plus-circle"></i>',
        requiresEdit: true,
        mobileVisible: true,
      }],
    },
    'users': {
      links: [{
        name: 'User list',
        route: '/users',
        slug: 'users',
        icon: '<i class="fa fa-list"></i>',
        requiresEdit: true,
        mobileVisible: true,
      }, {
        name: 'Add User',
        route: '/create-user',
        slug: 'create-user',
        icon: '<i class="fa fa-plus-circle"></i>',
        requiresEdit: true,
        mobileVisible: true,
      }],
    },
  },
};
